import getSelectionData from '../common/getSelectionData';
import fetchReferences from './fetchReferences';
import mapDataToTemplate from './mapDataToTemplate';

/**
 * Returns a callback to load data based on index and offset.
 * The data is then mapped to templates and passed to a masonry component.
 * @param {Element} component
 * @param {jQuery} $itemTemplate
 * @return {Function} A callback function
 */
const handleLoad = (component, $itemTemplate) => async () => {
    const $loader = $(component).find('.loader');
    const $filter = $(component).find('.references__filter');

    // set loading flag
    $(component).attr('data-loading', true);
    $loader.attr('data-active', true);

    // read index and offset or fall back to default values
    const url = $(component).attr('data-request-url');
    const method = $(component).attr('data-request-method');
    const index = Number($(component).attr('data-index')) || 0;
    const offset = Number($(component).attr('data-offset')) || 6;
    const resultKey = $(component).attr('data-initial-result-key') || 'referenceListItems';
    const results = window[resultKey] || (
        await fetchReferences(url, method, {
            index,
            offset,
            filters: getSelectionData($filter),
        })
    );
    const items = mapDataToTemplate(results.data, $itemTemplate);

    // an index of 0 indicates that we want to init/reset
    // the displaying masonry component.
    const event = index === 0 ? 'masonry:reset' : 'masonry:append';
    $(component).find('.masonry').trigger(event, [items]);

    $(component).attr('data-index', index + offset);
    // unset loading flag
    $(component).attr('data-loading', false);
    $loader.attr('data-active', false);
    // hide loader when total amount of items have been received
    $loader.toggle(index + offset < results.totalItems);

    // clear initial result
    if (window[resultKey]) window[resultKey] = null;
};

export default handleLoad;



// WEBPACK FOOTER //
// ./src/scripts/components/references/handleLoad.js